import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerProfilePosts.graphql';
import { Query, QueryinfluencerProfilePostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerProfilePostsQuery = (options?: QueryHookOptions<Query, QueryinfluencerProfilePostsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerProfilePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerProfilePostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerProfilePostsArgs>
): QueryResult<Query, QueryinfluencerProfilePostsArgs> & {
  getInfluencerProfilePosts: LazyQueryExecFunction<Query, QueryinfluencerProfilePostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerProfilePosts, result] = useLazyQuery<Query, QueryinfluencerProfilePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerProfilePosts, ...result };
};

export const useInfluencerProfilePostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerProfilePosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerProfilePostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerProfilePostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerProfilePosts };
};
// Suspense Query Hooks
export const useInfluencerProfilePostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerProfilePostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerProfilePostsArgs>(QUERY, {
    ...options
  });

  return result;
};
